import { IPhoneNumberNormalizationSettings } from '@nimbus-library/features/user-settings/models/i-phone-number-translation-settings';

export enum AcTeamMembershipType {
  Tm = 'tm',
  Lucs = 'lucs',
  Nimbus = 'nimbus',
}

export enum AcPermission {
  Deny,
  Allow,
}

export enum AcConversationAsService {
  NoConversations,
  InternalConversations,
  ExternalConversations,
  AllConversations,
}

export enum AcRetargetType {
  NoRetarget,
  AvCallsOnly,
  AllConversations,
}

export enum AcRetargetSource {
  RedirectPSTNCallsOnly,
  RedirectAllConversations,
  RedirectPSTNAndFederation,
  RedirectNonAgentsOnly,
}

export enum AcRecordingMode {
  Full,
  NoRecording,
  OnDemand,
}

export interface IAcTeamMembership {
  lucsActive: boolean;
  tmActive: boolean;
  nimbusActive: boolean;
  normalizationRule?: IPhoneNumberNormalizationSettings;
}

export interface AcTrait {
  traitNode: string;
  attribute: string;
}

export interface AcProfile {
  name: string;
  responsibilities: AcResponsibility[];
}

export interface AcResponsibility {
  traitNode: string;
  responsibility: string;
}

export interface AcRole {
  organizationUnit: string;
  role: string;
  permission: AcPermission;
}

export interface AcCapabilities {
  im: boolean;
  audio: boolean;
  video: boolean;
  desktopSharing: boolean;
  conversationContext: boolean;
}

export interface AcUser {
  id: string;
  displayName: string;
  sipUri?: string;
  firstName?: string;
  lastName?: string;
  organizationUnitNodeId?: string;
  sid?: string;
  sam?: string;
  upn?: string;
  email?: string;
  isSelectable?: boolean;
  presenceToken?: string;
  presenceState?: string;
  capabilities?: AcCapabilities;
  isBlockedByLuwareApi?: boolean;
  currentProfile?: string;
  defaultProfile?: string;
  notReadyReason?: string;
  notSelectableReason?: string;
  aAConfiguration?: string;
  numberOfSimultaneousIm?: number;
  conversationAsService?: AcConversationAsService;
  isBusySelectable?: boolean;
  isBusyInAMeetingSelectable?: boolean;
  showAwayAsOffline?: boolean;
  busyOnBusyInACallEnabled?: boolean;
  canLoginToRecordingManager?: boolean;
  retargetType?: AcRetargetType;
  retargetSource?: AcRetargetSource;
  retargetTo?: string;
  retargetPrivateNumber?: boolean;
  retargetOnlyIfInDutyProfile?: boolean;
  recordingType?: AcRecordingMode;
  traits?: AcTrait[];
  profiles?: AcProfile[];
  roles?: AcRole[];
}
